import React from 'react';
import {i18n_get_value, I18N_LABELS} from '../../../i18n/i18n_scripts';

const OrdersDetails = ({orders, order, drivers}) => {

    if (order){
    return (
        <div id="modal" key={order.id} className="order__modal-container"
        style={{top: `${orders.order.activeOrderDimensionsHeight &&
        (orders.order.activeOrderDimensionsHeight)}px`}} >
            <h5 className="order__modal-text"><b>{i18n_get_value(I18N_LABELS.SIDEBAR_DELIVERY_PROCESS)}:</b> <span>{order.id ? order.id : null}</span></h5>
            <h5 className="order__modal-text"><b>{i18n_get_value(I18N_LABELS.SIDEBAR_DELIVERY_NAME)}:</b> <span>{order.customerName ? order.customerName : null}</span></h5>
            <h5 className="order__modal-text"><b>{i18n_get_value(I18N_LABELS.SIDEBAR_DELIVERY_STATE)}:</b> <span>{order.status ? order.status : null}</span></h5>
            {
            drivers.filter(driver => driver.id === order.driverId).map( driver => (
                <h5 className="order__modal-text"><b>{i18n_get_value(I18N_LABELS.SIDEBAR_DELIVERY_DRIVER)}:</b> <span>{driver.name ? driver.name : null}</span></h5>
            ))}
            {!order.driverId && (
                <h5 className="order__modal-text"><b>{i18n_get_value(I18N_LABELS.SIDEBAR_DELIVERY_DRIVER)}:</b> <span>{i18n_get_value(I18N_LABELS.NO_SIDEBAR_DELIVERY_DRIVER)}</span></h5>
            )}
        </div>
            )
    }
    return null;
}

export default OrdersDetails;